import { Component } from '@angular/core';
import { NavController, NavParams, ToastController, AlertController, PopoverController } from 'ionic-angular';
import { DIC } from '../../dic';
import { GN } from '../../../gn';
import { PopupPage } from '../../popup/popup';
/**
 * Generated class for the EditschedulePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-editschedule',
  templateUrl: 'editschedule.html',
})
export class EditschedulePage {
  sc: any;
  Title = ''
  _reporting: string = ''
  _vehicleasd: any
  _timerangeasd: string = ''
  _periodarrival: string = ''
  _timeofarrival: string = ''
  _dayarrival: string = ''
  _toemails: string = ''
  pdftoggle: boolean = true;
  xlsletoggle: boolean = false;
  cb: any;
  _dayMonth: number = -1


  schedulerID = -1
  scDay = ''

  selectedVehiclesIds = [0]

  selectedVehiclesText = ''
  groupPois = []
  _groupPois: number = 0
  _worktimeData: number = 0 //0-both; 1-in; 2-out
  reportGenerator = []

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public gn: GN, public toastCtrl: ToastController, public alertCtrl: AlertController, public popoverCtrl: PopoverController) {

    if (navParams.get('sc') != null) {
      this.sc = navParams.get('sc')
      this.schedulerID = this.sc.id
      this.cb = navParams.get('cb');
      this.Title = this.dic.l["editschedule"]
      // console.log(this.sc)
      if (this.sc.repid != 0) {
        this._reporting = 'CustomizedReport' + this.sc.repid
      } else {
        this._reporting = this.sc.repname
        if (this._reporting == 'RoutingVehicles') {
          this._reporting = 'routingvehicles'
        }

        if (this._reporting == 'RoutingDrivers') {
          this._reporting = 'routingdrivers'
        }
      }
      this._vehicleasd = this.sc.vehid;
      this._periodarrival = this.sc.period; // Daily
      this._timeofarrival = this.sc.time // time 00:00 ...
      this._dayarrival = this.sc.day // Monday, Th....
      this.scDay = this.sc.day
      this._toemails = this.sc.email
      this._timerangeasd = this.sc.range // Last1 , Last2 ...
      this._dayMonth = this.sc.daymonth

      if (this._reporting == 'VehiclePOI') {
        this._groupPois = this.sc.settings
      }
      if (this._reporting == 'WorktimeReport') {
        this._worktimeData = this.sc.settings
      }

      var ka
      ka = this.sc.vehid.split(',')
      for (let i = 0; i < ka.length; i++) {
        parseFloat(ka[i])
        this.selectedVehiclesIds.push(parseFloat(ka[i]))
      }
      this.selectedVehiclesIds.shift()
      if (this.selectedVehiclesIds.length == 1) {
        for (let j = 0; j < this.selectedVehiclesIds.length; j++) {
          if (this.selectedVehiclesIds[j] + '' == '0') {
            this.selectedVehiclesText = this.dic.l["allvehicles"]
          }
          if (this.selectedVehiclesIds[j] + '' != '0') {
            this.selectedVehiclesText = this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehiclesIds[0]]].registration + ' (' + this.gn.Vehicles[this.gn.VehiclesDic[this.selectedVehiclesIds[0]]].code + ')'
          }
          // else {
          //   this.selectedVehiclesText = this.selectedVehiclesIds.length + '' + ' ' + this.dic.l["vehicles"]
          // }
        }
      }
      else {
        this.selectedVehiclesText = this.selectedVehiclesIds.length + '' + ' ' + this.dic.l["vehicles"]

      }


      // this.selectedVehiclesIds.push(this.sc.vehid.split(','))

      console.log(this.selectedVehiclesIds, 'daj tuka da te vidam')
      // this.selectedVehiclesIds = this.sc.vehid
      // update scheduler set report=_reporting, vehid=_vehicleasd,  where id=schid
      // var regveh
      // if (this._vehicleasd + '' != '') {
      //   regveh = this.gn.Vehicles[this.gn.VehiclesDic[this._vehicleasd]].registration + ' ' + '(' + this.gn.Vehicles[this.gn.VehiclesDic[this._vehicleasd]].code + ')'
      //   this.selectedVehiclesText = regveh
      // }

      if (this.sc.doctype == 'pdf') {
        this.toggleDoctype('pdf', true)
      } else {
        this.toggleDoctype('xls', true)
      }
    } else {
      this.Title = this.dic.l["addschedule"]
      this._reporting = navParams.get('rep')
      this._vehicleasd = navParams.get('vid')
      this.cb = navParams.get('cb');

      this._worktimeData = navParams.get('settings');
      //debugger
    }

  }
  loadGroupPois() {
    var _that = this
    this.gn._Post('/api/gn/getpoisGroupforScheduler', { cid: this.gn.crypt(this.gn.user.ClientId) }, function (_data) {
      _that.groupPois = _data
      console.log('bosko', _data)
    })

  }


  proba() {
    // console.log(this._dayMonth, 'day pri promena')



  }





  toggleDoctype(momStr: any, flag: any) {

    if (momStr == 'pdf') {
      this.pdftoggle = flag;
      this.xlsletoggle = !this.pdftoggle;
    }
    if (momStr == 'xls') {
      this.xlsletoggle = flag;
      this.pdftoggle = !this.xlsletoggle
    }

  }
  ionViewDidLoad() {
    var _that = this
    this.gn._Post('/api/gn/reports/getallreportgeneratornames', { uid: this.gn.crypt(this.gn.user.UserId) }, function (_data) {
      for (var i = 0; i < _data.repgen.length; i++) {
        _that.reportGenerator.push({ title: _data.repgen[i].name, id: _data.repgen[i].id })
      }
    })

    console.log(this._vehicleasd, 'daj da te zirnam kako mozes da bides 0')
    if (this.selectedVehiclesText == '') {
      this.selectedVehiclesText = this.dic.l["allvehicles"]
    }
    this.loadGroupPois()

    // console.log('ionViewDidLoad EditschedulePage');

    // if (this._vehicleasd + '' == '0') {
    //   this.selectedVehiclesText = 'Site Vozila'
    // }

    // var regveh
    // if (this._vehicleasd + '' != '') {
    //   regveh = this.gn.Vehicles[this.gn.VehiclesDic[this._vehicleasd]].registration + ' ' + '(' + this.gn.Vehicles[this.gn.VehiclesDic[this._vehicleasd]].code + ')'
    //   this.selectedVehiclesText = regveh
    // }



  }

  changePeriod() {
    if (this.scDay == '' && this._periodarrival == 'Weekly') {
      this._dayarrival = 'Monday'
    }
    if (this._periodarrival == 'Daily') {
      this._dayarrival = ''
    }
  }

  emailValidate(value) {
    var emailovi = value.split(",");
    var izlez;
    var _ret = false
    emailovi.forEach(function (mejl) {
      var filter = new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i);
      izlez = filter.test(mejl.trim());
      if (!izlez) {
        _ret = true;
        return izlez;
      }
    });
    if (!_ret) {
      return izlez;
    }
  }

  Edit() {
    // if (this.schedulerID==-1){
    //   this.navCtrl.pop();
    //   return
    // }
    if (this._reporting == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["scinfo4"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    // if (this._vehicleasd==''){
    //   let toast = this.toastCtrl.create({ message: this.dic.l["choosevehicle"], duration: 3000, position: 'top' });
    //   toast.present();
    //   return
    // }
    if (this._periodarrival == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["scinfo3"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._dayarrival == '' && this._periodarrival == 'Weekly') {
      let toast = this.toastCtrl.create({ message: this.dic.l["scinfo2"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._timeofarrival == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["scinfo1"], duration: 3000, position: 'top' });
      toast.present();
      return
    }
    if (this._toemails == '') {
      let toast = this.toastCtrl.create({ message: this.dic.l["usinfo02"], duration: 3000, position: 'top' });
      toast.present();
      return
    }

    if (this._periodarrival == 'Monthly') {
      if (this._dayMonth == -1) {
        let toast = this.toastCtrl.create({ message: this.dic.l["choosedayformonth"], duration: 3000, position: 'top' });
        toast.present();
        return
      }
    }





    var _that = this;
    var vehicleReg = '0'
    var doctype = ''
    if (this._vehicleasd + '' == '1') {
      vehicleReg = this.gn.Vehicles[this.gn.VehiclesDic[this._vehicleasd]].registration
    }
    if (this.pdftoggle == true) {
      doctype = 'pdf'
    }
    else {
      doctype = 'xls'
    }
    var vehicleIds
    vehicleIds = this.selectedVehiclesIds.toString()
    var vehicleText
    vehicleText = this.selectedVehiclesText.toString()


    if (this._periodarrival != 'Monthly') {
      this._dayMonth = -1
    }

    if (this._periodarrival != 'Weekly') {
      this._dayarrival = ''
    }

    if (this._reporting == 'routingvehicles') {
      this._reporting = 'RoutingVehicles'
    }

    if (this._reporting == 'routingdrivers') {
      this._reporting = 'RoutingDrivers'
    }
    if (this._toemails + '' != '' && this.emailValidate(this._toemails) != true) {
      let toast = this.toastCtrl.create({ message: this.dic.l["enteremail"], duration: 3000, position: 'top' });
      toast.present();
      return
    } else {
      this._toemails = this._toemails.replace(/\s/g, "")
    }

    var _repid = 0;
    if (this._reporting.indexOf('CustomizedReport') != -1) {
      _repid = parseInt(this._reporting.split('CustomizedReport')[1]);
      this._reporting = 'CustomizedReport';
    }

    var _settings = this._groupPois;
    if (this._reporting == 'WorktimeReport') {
      _settings = this._worktimeData;
    }

    var dat = {
      sid: this.gn.crypt(this.schedulerID),
      cid: this.gn.crypt(this.gn.user.ClientId),
      uid: this.gn.crypt(this.gn.user.UserId),
      report: this.gn.crypt(this._reporting),
      repid: this.gn.crypt(_repid),
      vehicle: this.gn.crypt(vehicleText),
      period: this.gn.crypt(this._periodarrival),
      day: this.gn.crypt(this._dayarrival),
      time: this.gn.crypt(this._timeofarrival),
      email: this.gn.crypt(this._toemails),
      range: this.gn.crypt(this._timerangeasd),
      vehid: this.gn.crypt(vehicleIds),
      doctype: this.gn.crypt(doctype),
      settings: this.gn.crypt(_settings),
      daymonth: this.gn.crypt(this._dayMonth)
    }
    this.gn._Post('/api/gn/editschedule', dat, function (_data) {
      _that.navCtrl.pop();
      _that.cb();
    })


  }

  openVehiclePopup(_ev) {
    var oo = false
    var _that = this
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'scheduler', onlyonevehicle: oo, selected: _that.selectedVehiclesIds, scheduleidselectedveh: _that._vehicleasd, callback: function (_text, _ids) {
        console.log(_ids, 'ids')
        _that.selectedVehiclesIds = _ids
        console.log(_that.selectedVehiclesIds, 'selected')

        console.log(_text, 'daj da vidam text')
        _that.selectedVehiclesText = _text

      }
    });



    popover.present({
      ev: _ev
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/schedule/editschedule.ts